import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { useLocation } from "@reach/router"
import GlobalPopUpForm from "../../components/forms/global-popup-form"
import Modal from 'react-bootstrap/Modal'
import parse from "html-react-parser"

const GlobalFormModal = (props) => {
    const data = useStaticQuery(graphql`
      query GlobalPopup {
        glstrapi {
          globalConfig {
                show_popup
                show_popup_form
                popup_form_pages
                popup_form {
                    id
                    _id
                    form_name
                    cta
                    link
                    mail
                    popup_time
                    title_content
                    image {
                        alternativeText
                        url
                    }
               }
           }
          
        }
      }
    `);
    //console.log("dataaaaa", data)


    const popup_form = data?.glstrapi?.globalConfig?.popup_form
    const { pathname, href } = useLocation();
    let popup_form_pages = data?.glstrapi?.globalConfig?.popup_form_pages;
    let show_popup = data?.glstrapi?.globalConfig?.show_popup;
    let show_popup_form = data?.glstrapi?.globalConfig?.show_popup_form;
    const { title_content, image, cta, mail, link, formname } = popup_form;
    const [show, setShow] = useState(false)
    const [render, setRender] = useState(false)
    const handleClose = () => setShow(false);
    useEffect(() => {
        let isMatch = false;
        let splitSlug = (popup_form_pages) ? popup_form_pages?.split(',') : [];
        if (popup_form_pages == "all") {
            isMatch = true
        } else if (popup_form_pages) {
            pathname.split('/').map((slug) => {
                if (slug && splitSlug.includes(slug)) {
                    isMatch = true
                }
            })
            if(popup_form_pages.includes("home") && pathname == "/"){
               isMatch = true   
            }
        }

        if (link && link == href) {
            isMatch = false
        }

        setTimeout(() => {
            if (splitSlug && isMatch && show_popup && !render) {
                setShow(isMatch)
                setRender(isMatch)
            }
        }, 10000)
        if(props?.showGlobalForm && !show){
           setShow(true) 
        }
    }, [props?.showGlobalForm])
    return (
        <Modal
            show={show}
            onHide={() => {
                setShow(false)
                props?.closeGlobalForm(false)
            }}
            dialogClassName={`global-modal-popup modal-form-wrapper form-page-wrapper ${!show_popup_form ? "no-modal-form" : ""}`}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Link to={link ? link : ""} className={`popup-form-modal-img-section ${image === "" || image?.length === 0  ? "popup-without-image" : ""} `}>
                <img
                    src={image[0]?.url}
                    alt=""
                    className="joinus-img"
                />
            </Link>
            <div className={`content ${image === "" || image?.length === 0  ? "popup-without-image" : ""} `}>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <div className="form-page-heading">

                            <div className="content-section">
                                {title_content &&
                                    parse(title_content)
                                }
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="popup-form-modal-body">

                    <div className="popup-form-modal-content">
                        {show_popup_form &&
                            <div className="form-page-form-details global-popup-form">
                                <GlobalPopUpForm cta={cta} to_email_id={mail} formname={formname} />
                            </div>
                        }
                        {!show_popup_form &&
                            <div className="popup-cta-sec">
                              <Link to={link} className="btn btn-banner">{cta}</Link>    
                            </div>      
                        }

                    </div>
                </Modal.Body>
            </div>

        </Modal>

    )
}

export default GlobalFormModal
